import { useEffect, useState } from 'react';

const VIEWPORT_MOBILE = '(max-width: 768px)';
const TOUCH_DEVICE = '(hover: none) and (pointer: coarse)';
const COMPACT_CASINO_GAME =
  '(max-width: 768px), ((hover: none) and (pointer: coarse)), ((orientation: landscape) and (min-width: 600px) and (max-width: 1280px))';

function readMatches(query) {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(query).matches;
}

function readIsMobile() {
  return readMatches(VIEWPORT_MOBILE) || readMatches(TOUCH_DEVICE);
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(readIsMobile);

  useEffect(() => {
    const viewportMq = window.matchMedia(VIEWPORT_MOBILE);
    const touchMq = window.matchMedia(TOUCH_DEVICE);
    const sync = () => setIsMobile(readIsMobile());
    viewportMq.addEventListener('change', sync);
    touchMq.addEventListener('change', sync);
    return () => {
      viewportMq.removeEventListener('change', sync);
      touchMq.removeEventListener('change', sync);
    };
  }, []);

  return isMobile;
}

export function useCompactCasinoGame() {
  const [compact, setCompact] = useState(() => readMatches(COMPACT_CASINO_GAME));

  useEffect(() => {
    const mq = window.matchMedia(COMPACT_CASINO_GAME);
    const sync = () => setCompact(mq.matches);
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  return compact;
}
